"use client";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import GetNumber from "./GetNumber";
import ConfirmNumber from "./ConfirmNumber";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { checkOtp, getOtp } from "@/services/authService";
import { LoginWithNumberProps } from "@/types/LoginType";
import { useRouter } from "next/navigation";
import useToast from "@/hooks/useToast";

function LoginWithNumber() {
  //  Custom Hooks  //
  const router = useRouter();
  const {
    reset,
    formState: { isValid, errors },
    handleSubmit,
    register,
  } = useForm<LoginWithNumberProps>({ mode: "onChange" });
  const { showError, showSuccess } = useToast();

  //  Global State  //
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [redirectPaths, setRedirectPath] = useState<string | null>(null);
  //  Api Hook  //

  const { mutateAsync: mutateGetOtp, isPending: isLoadingGetOtp } = useMutation(
    { mutationFn: getOtp, retry: 2, retryDelay: 1000 }
  );
  const { mutateAsync: mutateCheckOtp, isPending: isLoadingCheckOtp } =
    useMutation({
      mutationFn: checkOtp,
      retry: 2,
      retryDelay: 1000,
    });
  //  State  //
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  //  Function  //

  const getNumberHandler = async (value: LoginWithNumberProps) => {
    try {
      const data = await mutateGetOtp({ mobileNumber: value?.mobileNumber });
      if (data?.success) {
        setStep(2);
        showSuccess(`${data?.message}${data?.confirmCode}`);
        setMobileNumber(value?.mobileNumber);
      } else {
        setIsError(true);
        if (data?.message) {
          setErrorMessage(data.message);
        }
        showError(data?.message);
      }
    } catch (error) {
      console.error("get OtpCode by phone failed:", error);
    }
  };
  const confirmNumberHandler = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) e.preventDefault();

    try {
      const response = await mutateCheckOtp({
        mobileNumber,
        confirmCode: otp,
      });

      if (!response?.success) {
        toast.error(response?.message);
        return;
      }

      Cookies.set("AccessToken", response.data.jwtToken, {
        secure: true,
        sameSite: "Lax",
      });

      Cookies.set("mobileNumber", String(response.data.mobileNumber));

      const fullName = `${response.data.firstName ?? ""} ${
        response.data.lastName ?? ""
      }`.trim();

      Cookies.set("name", fullName || "کاربر");

      if (!response.data.firstName) {
        window.location.href = "/dashboard/profile";
      } else if (redirectPaths) {
        window.location.href = redirectPaths;
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Confirm OTP failed:", error);
      toast.error("خطا در تایید کد");
    }
  };

  //  Effect  //

  useEffect(() => {
    if (redirectPaths) {
      router.push(redirectPaths);
    }
  }, [redirectPaths]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get("redirect");
      setRedirectPath(redirect);
    }
  }, []);

  useEffect(() => {
    if (otp.length === 5) {
      confirmNumberHandler();
    }
  }, [otp]);

  return (
    <>
      {/* If Error Error Message Will Be See Here */}
      {isError && (
        <p className="text-sm text-red-500 text-center text-error">
          {errorMessage}
        </p>
      )}
      <h2 className="text-2xl mt-3 text-ws-gray-600  w-full">ورود | ثبت نام</h2>
      {/* Get Number handler Component */}
      {step === 1 ? (
        <GetNumber
          onSubmit={getNumberHandler}
          isValid={isValid}
          handleSubmit={handleSubmit}
          register={register}
          errors={errors}
          isLoading={isLoadingGetOtp}
          setMobileNumber={setMobileNumber}
          setStep={setStep}
        />
      ) : step === 2 ? (
        // Confirm Number Handler Component
        <ConfirmNumber
          otp={otp}
          reset={reset}
          setOtp={setOtp}
          onSubmit={confirmNumberHandler}
          isLoading={isLoadingCheckOtp}
          mobileNumber={mobileNumber}
          setStep={setStep}
        />
      ) : null}
      <ToastContainer limit={1} />
    </>
  );
}

export default LoginWithNumber;
